import { multiStep } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/multiStep'
import { useField, useFormikContext } from 'formik'
import { SimpleScheduleSelector } from './ScheduleSelector/SimpleScheduleSelector'
import { CustomSchedule } from './ScheduleSelector/CustomSchedule/CustomSchedule'
import { TimeOfDay } from './ScheduleSelector/types'
import { useEffect } from 'react'

export const PostTimes = multiStep(({ schema, submit, getSchemaField }) => {
  const { meta } = schema.describe()
  const formik = useFormikContext<any>()
  const [{ value: postTime }, , { setValue: setPostTime }] = useField<TimeOfDay>('post_time')

  const hasCustomScheduleSupport = Boolean(getSchemaField('custom_schedule_data'))
  const showAdvanced = formik.values.is_custom_schedule && hasCustomScheduleSupport
  const title = meta.title || 'When do you want to post?'

  useEffect(() => {
    if (formik.values.is_custom_schedule) setPostTime(TimeOfDay.Custom)
  }, [formik.values.is_custom_schedule, setPostTime])

  if (showAdvanced) {
    return (
      <CustomSchedule
        value={formik.values.custom_schedule_data || { selectedDays: [], dayTimeSelections: {} }}
        onChange={(customScheduleData) => formik.setFieldValue('custom_schedule_data', customScheduleData)}
        onComplete={submit}
        onBack={() => {
          formik.setFieldValue('is_custom_schedule', false)
          setPostTime(TimeOfDay.Morning)
        }}
      />
    )
  }

  return (
    <SimpleScheduleSelector
      value={{
        timeOfDay: postTime,
        customTime: formik.values.custom_schedule_data?.dayTimeSelections?.['all']?.customTime,
      }}
      onChange={({ timeOfDay, customTime }) => {
        setPostTime(timeOfDay)
        if (customTime) {
          formik.setFieldValue('custom_schedule_data', {
            selectedDays: [],
            dayTimeSelections: {
              all: { day: 'all', timeType: TimeOfDay.Custom, customTime },
            },
          })
        }
      }}
      onComplete={submit}
      title={title}
    />
  )
})
